export const API_HOST = process.env.REACT_APP_API_HOST;
export const IMAGE_HOST = process.env.REACT_APP_IMAGE_HOST;
